module.exports = __webpack_public_path__ + "static/media/wonky2.17f5ec30.jpg";